module.exports = __webpack_public_path__ + "img/xchange.16e5f280.png";